import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class GlobalSettingsService {
  // Hide BP
  isDeleg  = localStorage.getItem('isDeleg') ? localStorage.getItem('isDeleg') : null;
  bpStatus: any = localStorage.getItem('bpFeatures') ? localStorage.getItem('bpFeatures') : 'activé';
  // tslint:disable-next-line
  bpDisplayState: any = this.bpStatus === 'activé' ? true : this.bpStatus === 'désactivé' ? false : null;
  bpEnvState: boolean = false;
  constructor(
  ) {
  }

  // Cacher BP
  hideBp(): void {
    localStorage.setItem('bpFeatures', 'désactivé');
  }

  // Afficher
  unmaskBp(): void {
    localStorage.setItem('bpFeatures', 'activé');
  }

  undeleg(): void {
    localStorage.setItem('isDeleg', 'désactivé');
    this.isDeleg = 'désactivé'
  }

  // Afficher
  deleg(): void {
    localStorage.setItem('isDeleg', 'activé');
    this.isDeleg = 'activé'
  }

  /**
   * true = activé - BPs affichés
   * false = désactivé - BPs masqués
   */
  hideUnmaskBp(): void {
    if (environment.BP_ACTIF && this.bpStatus === 'activé') {
      this.hideBp();
    } else {
      if (this.bpStatus === null && environment.BP_ACTIF) {
        this.hideBp();
        this.unmaskBp();
      }
      if (this.bpStatus !== null && this.bpStatus === 'désactivé') {
        this.unmaskBp();
      }
    }
    location.reload();
  }

  delegation(): void {
    environment.ISDELEG = !environment.ISDELEG;
    if (environment.ISDELEG && this.isDeleg === 'activé') {
      this.undeleg();
    } else {
      if (this.isDeleg === null && environment.ISDELEG) {
        this.undeleg();
        this.deleg();
      }
      if (this.isDeleg !== null && this.isDeleg === 'désactivé') {
        this.deleg();
      }
    }
  }

  getBpDisplayStatus(): any {
    if (this.bpStatus) {
      return this.bpStatus;
    } else {
      return null;
    }
  }

}
